import { createContext, useContext } from 'react';

const InsideModalContext = createContext(false);

export const InsideModalProvider = InsideModalContext.Provider;

export const useInsideModal = () => useContext(InsideModalContext);

export interface ModalSlots {
  header: HTMLElement | null;
  footer: HTMLElement | null;
  requestFooter: () => () => void;
}

const ModalSlotsContext = createContext<ModalSlots | null>(null);

export const ModalSlotsProvider = ModalSlotsContext.Provider;

export const useModalSlots = () => useContext(ModalSlotsContext);
